/// <amd-module name="Dashboards/DashboardView/src/components/complementary/InlineConfigFiller" />
import * as React from "react";

import { widgetConfigUsesWideFormat } from "Dashboards/WidgetContractServices/WideConfigPanelPolicy";

interface InlineConfigFillerProps {
    /** The ID of the widget contribution under configuration */
    contributionId: string;
}

/**
 * Used to help prevent widgets from overlapping with the config modal dialog by shrinking the dashboard
 * grid viewport to simulate the config (a modal dialog) rendering inline with the dashboard grid.
 */
export class InlineConfigFiller extends React.PureComponent<InlineConfigFillerProps> {
    public render(): JSX.Element | null {
        return <div className="inline-config-filler flex-noshrink" style={{ flexBasis: `${this.getWidth()}px` }} />;
    }

    private getWidth(): number {
        // Config panel width +16px for the gap between the right edge of the modal dialog and the edge of the window
        return widgetConfigUsesWideFormat(this.props.contributionId) ? 571 : 456;
    }
}
